import * as React from "react";
const SvgFiRrBookArrowRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-book-arrow-right_svg__a)">
      <path
        fill="#062147"
        d="m23.133 12.093-1.614 1.614c-.929.921-2.335-.486-1.414-1.414L21.398 11H13c-1.308-.006-1.307-1.995 0-2h8.398l-1.293-1.293c-.921-.928.486-2.335 1.414-1.414l1.614 1.614a2.963 2.963 0 0 1 0 4.186M20 16v3c0 2.757-2.243 5-5 5H4c-2.206 0-4-1.794-4-4V5c0-2.757 2.243-5 5-5h10a5 5 0 0 1 4.843 3.75 1 1 0 0 1-1.938.499A3 3 0 0 0 15 1.999H6v14h12c.006-1.308 1.995-1.307 2 0zM2 5v11.556A3.96 3.96 0 0 1 4 16V2.184A3 3 0 0 0 2 5m16 14v-1H4c-2.629.047-2.627 3.953 0 4h11c1.654 0 3-1.346 3-3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-book-arrow-right_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBookArrowRight;
